interface IWelcome {
  "header-de": string,
  "text-de": string,
  "button-de": string,
  "header-ro": string,
  "text-ro": string,
  "button-ro": string
}

export const welcome: IWelcome = {
  "header-de": "Willkommen",
  "text-de": `Gottes Liebe ist für jeden. Wir sind hier, um sie mit Dir zu teilen.`,
  "button-de": "Mehr dazu",
  "header-ro": "Bine ați venit",
  "text-ro": `Dragostea lui Dumnezeu este pentru toți. De aceea suntem aici ca să o împărtășim cu tine.`,
  "button-ro": "Află mai multe"
}


